export default "__VITE_ASSET__B2K_YL7p__"